module.exports = __webpack_public_path__ + "static/media/PlayVideoWhite.808ca78a.svg";